<template>
  <div id="app">
    <!-- <kefuChart></kefuChart> -->
    <router-view></router-view>
    <watermark></watermark>
  </div>
</template>

<script>
// import kefuChart from '../src/components/common/kefuChart'
import watermark from "@/components/watermark.vue";
export default {
  name: "app",
  data() {
    return {
      timer: null,
      schoolId: "",
    };
  },
  components: {
    // kefuChart
    watermark,
  },
  created() {
    this.schoolId = window.localStorage.getItem("school_id") || "";
  },
  watch: {
    $route(n, o) {
      if (n.fullPath != o.fullPath && n.fullPath.indexOf("Permission") < 0) {
        (() => {})(n.fullPath, 'fullpath');

        this.timer = setInterval(() => {
          let sId = window.localStorage.getItem("school_id") || "";
          (() => {})(this.schoolId, sId, "schoolId - sId");
          if (this.schoolId != sId && this.schoolId) {
            clearInterval(this.timer);
            // window.location.href = "/";
            // this.$router.push("/");
          }
        }, 500);
      }
    },
  }
};
</script>

<style lang="less">
@import url("assets/less/reset.less");
@import url("assets/less/common.less");
@import url("assets/iconfons/oldFonts/style.css");
@import url("assets/newFonts/style.css");

@import url("assets/iconfons/icon1/style.css");
@import url("assets/iconfons/icomoon-2020.09.09/style.css");

// @import url('assets/iconfons/icon2/style.css');
* {
  word-break: break-all;
}
#app {
  height: 100vh;
}
.el-tooltip__popper {
  word-break: break-all;
}

.call-phone-dialog {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10000;

  .callphone-dialog {
    padding: 40px;
    background-color: #fff;
    border-radius: 15px;
    position: relative;

    .close {
      position: absolute;
      right: -50px;
      top: -50px;
    }
    .title {
      color: #000;
      font-weight: bold;
    }
    .tips-1 {
      padding: 16px 0 36px;
      color: #999;
    }
    .tips-2 {
      color: #ff6d02;
    }
    .tips-process {
      width: 99px;
      height: 94px;
    }
    .title-1 {
      padding: 33px 0 36px;
    }
    .way {
      padding: 12px 0 35px;
    }
  }

  .callphone-button {
    width: 95%;
    height: 45px;
    margin: 0 auto;
    line-height: 45px;
    color: #fff;
    text-align: center;
    background-color: #20a8d8;
    font-size: 16px;
    border-radius: 6px;
    cursor: pointer;
  }
}

.tab-menu-list {
  .el-menu {
    display: flex;
    overflow-x: auto;
    overflow-y: hidden;
    border-bottom: 1px solid #ddd;
  }
  .el-menu-item {
    height: 100%;
    line-height: 45px;
    padding: 0 10px;
    color: rgb(42, 48, 77) !important;
    &:hover {
      background-color: #fff !important;
    }
    .router-link-exact-active {
      color: #20a8d8 !important;
      position: relative;

      &:after {
        content: "";
        position: absolute;
        bottom: -1px;
        left: 0;
        width: 100%;
        height: 2px;
        background-color: #20a8d8 !important;
      }
    }
  }
}
</style>
